import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import App from "./App";
import { ConfirmDialogProvider } from "@/components/ui/ConfirmDialog";
import { setupGlobalErrorHandlers } from "@/lib/services/errorReporting";
import { setupConnectivityMonitor } from "@/lib/services/connectivityMonitor";
import "./index.css";

// Captura unhandledrejection + window.onerror y los envía a errorReports
setupGlobalErrorHandlers();

// Avisa al usuario si pierde/recupera conexión
setupConnectivityMonitor();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmDialogProvider>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#363636",
              color: "#fff",
            },
          }}
        />
      </ConfirmDialogProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Ocultar el splash screen una vez React ha montado
requestAnimationFrame(() => {
  const splash = document.getElementById("insignia-splash");
  if (splash) {
    splash.classList.add("hidden");
    setTimeout(() => splash.remove(), 600);
  }
});
